import React from "react";
import classnames from "classnames";
import { observer, inject } from "mobx-react";
import { withRouter, Link } from "react-router-dom";


@inject("store")
@observer
class DesktopNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.tree = this.props.tree;
        this.navigationStore = this.props.store.navigation;
        this.navigateToPath = this.navigateToPath.bind(this);
        this.navigateToSiteUrl = this.navigateToSiteUrl.bind(this);
        this.setRef = this.setRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.addEvents = this.addEvents.bind(this);
    }

    setRef(node) {
        this.Ref = node;
    }
    addEvents() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {

        if (this.Ref && !this.Ref.contains(event.target)) {
            // remove handler
            document.removeEventListener('mousedown', this.handleClickOutside);
            this.props.tree.resetNavigation();
        }
    }

    navigateToSiteUrl(url, name) {
        //console.debug("navigateToSiteUrl path", url);
        this.navigationStore.navigateToSiteUrl(this.props.tree, url, name);
    }

    navigateToPath(childNodePath) {
        //console.debug("navigateTo path", childNodePath);
        this.addEvents();
        this.props.tree.navigateToPath(childNodePath);
    }

    render() {
        if (!this.tree) {
            console.debug("no tree", this.props);
            return null;
        }

        const classes = classnames(this.props.className, {
            "toolbar-open": this.props.store.navigation.isToolbarOpen
        });

        // Handle url-generation from Navigation to app
        return (
            <nav className={classes} ref={this.setRef}>

                <DesktopNavigationLevel
                    {...this.props}
                    tree={this.tree}
                    node={this.tree}
                    activePath={this.tree.ActivePath}
                    level={0}
                    navigateToSiteUrl={this.navigateToSiteUrl}
                    navigateToPath={this.navigateToPath}
                    navigationStore={this.navigationStore}
                />
            </nav>

        );
    }
}


@observer
class DesktopNavigationLevel extends React.Component {

    constructor(props) {
        super(props);
        // own component height

        this.state = {
            height: 0
        };

        this.tree = this.props.tree;
        this.navigationStore = this.props.navigationStore;
        this.resetNavigation = this.resetNavigation.bind(this);
        this.navigateToSiteUrl = this.navigateToSiteUrl.bind(this);
        this.navigateToPath = this.navigateToPath.bind(this);
    }

    resetNavigation() {
        this.props.closeTabs();
    }

    navigateToSiteUrl(event, url, name) {
        event.preventDefault();
        this.props.navigateToSiteUrl(url, name);
    }

    navigateToPath(event, childNodePath) {
        event.preventDefault();
        this.props.navigateToPath(childNodePath);
    }



    componentWillUnmount() {

    }

    componentDidMount() {

        //let { clientHeight } = this.element;

    }

    componentDidUpdate(prevProps, prevState) {

    }

    render() {
        const serverRender = typeof window === 'undefined';


        const activePath = this.props.activePath;
        const level = this.props.level;
        const node = this.props.node;
        let nodePath = this.props.nodePath;

        const pathname = serverRender ? this.navigationStore.serverLocation : this.navigationStore.mainRouter.location.pathname; // /1234/in-season/shoes

        let isMegamenu = this.props.isMegamenu || false;

        let navClass = "";
        
        let style = {};
        if (isMegamenu) {// && node.Alias === "icom_filter") {
            if(level === 1){
                navClass = "mega-menu";    
            }
            else if(level > 1){
                navClass = "";
            }
            
            //const num = node.Children.filter(x => x.Url !== "" && x.Visible).length;
            //style = {width: '' + (parseInt((num) * 10)+20) + '%', minWidth: num*170 + 'px', maxWidth: num*200 + 'px'};
            //isMegamenu = true;
        }
        else if (level >= 1) {
            navClass = "sub-menu";
        }
        if (!nodePath) {
            nodePath = [node.Id];
        }
        
        const navClasses = classnames(navClass, "nav-"+node.Id);
        
        if (level === 1 && isMegamenu) {
            
            const classes = classnames(
                "megamenu-container",
                node.Highlighted ? "divided-menu":null 
            );


            return (
                <div className={classes}>
                    <div className="megamenu-container-left"></div>
                    <ul className={navClasses} style={style}>
                        {node.Children.filter(x => x.Url !== "" && x.Visible).map(childNode => {
                            const childNodePath = nodePath.slice(0);
                            childNodePath.push(childNode.Id);
                            const name = childNode.Name;
                            const isOpen = activePath.indexOf(childNode.Id) > 0;

                            const childNodes = childNode.Children.filter(cn => cn.Alias !== "Page" && cn.Visible);
                            let hasChildren = childNodes.length > 0;
                            //console.log("childNode", childNode, hasChildren);

                            const menuGroup = childNode.Alias === "icom_menuGroup";
                            
                            let liClassNames = classnames(
                                menuGroup ? "menu-link-group" : "", // Link group without header, special css-rules 
                                (pathname.indexOf(childNode.Url) > -1) ? "active" : "",
                                isOpen ? "open" : "",
                                childNode.Highlighted ? "bold" : "",
                                childNode.IsDivider ? "divider" : ""
                            );

                            return (<li key={childNode.Id} className={liClassNames}>
                                { !menuGroup     
                                    ? hasChildren
                                        ? (level === 1 && isMegamenu
                                            ? (<a className="mega-menu-title" href={childNode.Url} onClick={event => this.navigateToSiteUrl(event, childNode.Url, name)}><span>{childNode.Name}</span></a>) 
                                            : (<a href={childNode.Url} onClick={event => { this.navigateToPath(event, childNodePath) }}><span>{childNode.Name}</span></a>))
                                        : (childNode.Url[0] === "/" 
                                            ? (<a href={childNode.Url} onClick={event => this.navigateToSiteUrl(event, childNode.Url, name)}><span>{childNode.Name}</span></a>) 
                                            : (
                                                <Link to={childNode.Url} onClick={this.resetNavigation}>
                                                    <span>{childNode.Name}</span>
                                                </Link>
                                            )
                                        )
                                    : null
                                }

                                {hasChildren ? (
                                    <DesktopNavigationLevel
                                        {...this.props}
                                        isMegamenu={isMegamenu}
                                        node={childNode}
                                        level={level + 1}
                                        nodePath={childNodePath}
                                    />)
                                    : (
                                        ""
                                    )}
                            </li>);
                        })}
                    </ul>
                    <div className="megamenu-container-right"></div>
                </div>
            );
        }
        else

            // todo: add filter from umbraco to hide icom_category in menu
            return (

                <ul className={navClasses}>
                    {node.Children.filter(x => x.Url !== "" && x.Visible && x.Alias !=="icom_category" && !x.IsHeading).map(childNode => {
                        const childNodes = childNode.Children.filter(cn => cn.Alias !== "Page" && cn.Visible)
                        const childNodePath = nodePath.slice(0);
                        childNodePath.push(childNode.Id);
                        const name = childNode.Name;
                        const isOpen = activePath.indexOf(childNode.Id) > 0;
                        let hasChildren = childNodes.length > 0;//childNode.Children.length > 0 && childNode.Alias !== "Page"; // do not display mega menu for old page type
                        let liClassNames = classnames(
                            
                            (pathname.indexOf(childNode.Url) > -1) ? "active" : "",
                            isOpen ? "open" : "",
                            childNode.Highlighted ? "bold" : "",
                            childNode.IsDivider ? "divider" : ""
                        );
                        return (<li key={childNode.Id} className={liClassNames} >
                            {childNode.IsDivider 
                                ? <span>{childNode.Name}</span> 
                                : hasChildren 
                                    ? (level === 0  
                                        ?(<a href={childNode.Url}
                                             onClick={event => { this.navigateToPath(event, childNodePath) }}><span>{childNode.Name}</span></a>) 
                                        :(<a href={childNode.Url}
                                            onClick={event => this.navigateToSiteUrl(event, childNode.Url, name)}><span>{childNode.Name}</span></a>))
                                         
                                    : (childNode.Url[0] === "/" 
                                        ? (<a href={childNode.Url}
                                            onClick={event => this.navigateToSiteUrl(event, childNode.Url, name)}
                                        ><span>{childNode.Name}</span></a>) 
                                        : (
                                            <Link to={childNode.Url} onClick={this.resetNavigation}>
                                                <span>{childNode.Name}</span>
                                            </Link>
                                        ))}
                            {hasChildren ? (
                                <DesktopNavigationLevel
                                    {...this.props}
                                    isMegamenu={isMegamenu}
                                    node={childNode}
                                    level={level + 1}
                                    nodePath={childNodePath}
                                />
                            ) : (
                                    ""
                                )}
                        </li>);
                    })}
                </ul>
            );
    }
}


export default withRouter(DesktopNavigation)